(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPritiReels() {
    var reelCards = document.querySelectorAll('.pt-reel-card');

    reelCards.forEach(function (card) {
      if (card.dataset.reelsReady === 'true') return;
      card.dataset.reelsReady = 'true';

      var hasVideo = card.getAttribute('data-has-video') === 'true';
      var reelLink = card.getAttribute('data-reel-link');
      var video = card.querySelector('.pt-reel-video');
      var playBtn = card.querySelector('.pt-reel-play');
      var clickArea = card.querySelector('.pt-reel-link');

      function isShopifyEditor() {
        return window.Shopify && window.Shopify.designMode;
      }

      function pauseOtherVideos() {
        document.querySelectorAll('.pt-reel-video').forEach(function (otherVideo) {
          if (otherVideo !== video) {
            otherVideo.pause();
            var otherCard = otherVideo.closest('.pt-reel-card');
            if (otherCard) {
              otherCard.classList.remove('is-playing');
              var otherBtn = otherCard.querySelector('.pt-reel-play');
              if (otherBtn) otherBtn.innerHTML = '▶';
            }
          }
        });
      }

      function toggleVideo(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (!video) return;

        if (video.paused) {
          pauseOtherVideos();
          video.play();
          card.classList.add('is-playing');
          if (playBtn) playBtn.innerHTML = '❚❚';
        } else {
          video.pause();
          card.classList.remove('is-playing');
          if (playBtn) playBtn.innerHTML = '▶';
        }
      }

      function openExternalLink(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (!reelLink) return;

        if (isShopifyEditor()) {
          console.log('Reel link disabled inside Shopify editor:', reelLink);
          return;
        }

        window.open(reelLink, '_blank', 'noopener,noreferrer');
      }

      if (hasVideo && video) {
        if (playBtn) {
          playBtn.addEventListener('click', toggleVideo);
        }

        if (clickArea) {
          clickArea.addEventListener('click', toggleVideo);
        }

        video.addEventListener('click', toggleVideo);

        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          if (playBtn) playBtn.innerHTML = '▶';
        });

        video.addEventListener('play', function () {
          card.classList.add('is-playing');
          if (playBtn) playBtn.innerHTML = '❚❚';
        });
      } else if (reelLink) {
        if (playBtn) {
          playBtn.addEventListener('click', openExternalLink);
        }

        if (clickArea) {
          clickArea.addEventListener('click', openExternalLink);

          clickArea.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              openExternalLink(event);
            }
          });
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initPritiReels);
  document.addEventListener('shopify:section:load', initPritiReels);
  document.addEventListener('shopify:section:select', initPritiReels);

  setTimeout(initPritiReels, 800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-products"] && !Shopify.designMode) return;
  try {
    
/* =====================================================
   MOBILE TOUCH DIRECTION FIX
===================================================== */
(function () {
  function setSwipe(slider, enabled) {
    if (!window.jQuery) return;
    var $slider = window.jQuery(slider);
    if (!$slider.hasClass('slick-initialized')) return;
    try {
      $slider.slick('slickSetOption', 'swipe', enabled, false);
      $slider.slick('slickSetOption', 'touchMove', enabled, false);
    } catch (e) {}
  }

  function bindMobileScrollFix() {
    if (window.innerWidth > 767) return;

    document.querySelectorAll('.banner-double-row-slider-area .product-double-row-slider-wrapper .ht-slick-slider').forEach(function (slider) {
      if (slider.dataset.ptScrollFixBound === 'true') return;
      slider.dataset.ptScrollFixBound = 'true';

      var startX = 0;
      var startY = 0;
      var decided = false;

      slider.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        decided = false;
        setSwipe(slider, true);
      }, { passive: true, capture: true });

      slider.addEventListener('touchmove', function (event) {
        if (!event.touches || !event.touches.length || decided) return;

        var diffX = Math.abs(event.touches[0].clientX - startX);
        var diffY = Math.abs(event.touches[0].clientY - startY);

        if (diffX < 6 && diffY < 6) return;

        if (diffY > diffX * 1.15) {
          setSwipe(slider, false);
        } else {
          setSwipe(slider, true);
        }

        decided = true;
      }, { passive: true, capture: true });

      slider.addEventListener('touchend', function () {
        setTimeout(function () { setSwipe(slider, true); }, 80);
      }, { passive: true });

      slider.addEventListener('touchcancel', function () {
        setTimeout(function () { setSwipe(slider, true); }, 80);
      }, { passive: true });
    });
  }

  function injectJudgeMeStars() {
    document.querySelectorAll('.banner-double-row-slider-area .pt-slider-product-hover-card').forEach(function (card) {
      var review = null;

      Array.prototype.forEach.call(card.children, function (child) {
        if (!review && child.classList && child.classList.contains('pt-judgeme-review')) {
          review = child;
        }
      });

      if (!review) return;

      var content = card.querySelector('.single-slider-product__content, .single-slider-product_content');
      if (!content || content.contains(review)) return;

      content.appendChild(review);
    });

    if (window.jdgm && typeof window.jdgm.refreshBadges === 'function') {
      try {
        window.jdgm.refreshBadges();
      } catch (e) {}
    }
  }

  function bindAllPtSliderFixes() {
    bindMobileScrollFix();
    injectJudgeMeStars();
    setTimeout(injectJudgeMeStars, 250);
    setTimeout(injectJudgeMeStars, 900);
  }

  document.addEventListener('DOMContentLoaded', bindAllPtSliderFixes);
  document.addEventListener('shopify:section:load', bindAllPtSliderFixes);
  window.addEventListener('resize', bindAllPtSliderFixes);
  setTimeout(bindAllPtSliderFixes, 500);
  setTimeout(bindAllPtSliderFixes, 1500);
})();

  } catch(e) { console.error(e); }
})();
})();
